{
  "ApiKeys_AddMode": "Vous devez d’abord créer un utilisateur avant de pouvoir créer une clé API.",
  "ApiKeys_Add_New": "Ajouter une nouvelle clé API...",
  "ApiKeys_RevokeButton": "Révoquer",
  "ApiKeys_RemoveButton": "Supprimer",
  "ApiKeys_TableHeader_Name": "Nom",
  "ApiKeys_TableHeader_Expiry": "Expiration",
  "ApiKeys_TableHeader_Created": "Créé",
  "ApiKeys_TableHeader_LastAccessed": "Dernier accès",
  "ApiKeys_TableHeader_Title": "Clés API",
  "ApiKeys_Validations_Required": "Requis",
  "ApiKeys_Name_Validations_MaxLength": "La longueur maximale est de 50",
  "ApiKeys_Revoke_ConfirmMessage": "Êtes-vous sûr de vouloir révoquer cette clé API ?",
  "ApiKeys_Revoke_Confirm": "Confirmer",
  "ApiKeys_Revoke_Cancel": "Annuler",
  "ApiKeys_Indefinite": "Jamais",
  "ApiKeys_Expired": "Expiré",
  "ApiKeys_Placeholder_Description": "Description",
  "ApiKeys_KeyDisplay_Title": "Jeton d'accès créé : « {} »",
  "ApiKeys_KeyDisplay_SubTitle": "Enregistrez ce jeton dans un endroit sécurisé, il ne pourra pas être visualisé ou récupéré une fois que vous aurez fermé cette fenêtre ou ajouté une autre clé",
  "ApiKeys_Copy_Success": "Copié dans le presse-papiers",
  "ApiKeys_Copy_Fail": "Échec de la copie dans le presse-papiers",
  "ApiKeys_MaxAPIKeysReached": "Vous avez atteint le nombre maximum de clés API, veuillez supprimer une clé existante avant de pouvoir en créer une nouvelle.",
  "NAME": "ApiKeys"
}